<template>
  <v-row>
    <v-col v-if="!keyInfo.issuerCN?.includes('DIIA')" class="py-0" cols="6">
      <div class="text-disabled">Назва компанії</div>
      <div class="font-weight-bold">
        {{ keyInfo.subjOrg || 'ФІЗИЧНА ОСОБА ПІДПРИЄМЕЦЬ' }}
      </div>
    </v-col>
    <v-col v-if="keyInfo.subjEDRPOUCode" class="py-0" cols="6">
      <div class="text-disabled">ЄДРПОУ</div>
      <div class="font-weight-bold">{{ keyInfo.subjEDRPOUCode }}</div>
    </v-col>

    <v-col v-if="keyInfo.subjFullName" class="py-0" cols="6">
      <div class="text-disabled">ПІБ</div>
      <div class="font-weight-bold">{{ keyInfo.subjFullName }}</div>
    </v-col>
    <v-col v-if="keyInfo.subjDRFOCode" class="py-0" cols="6">
      <div class="text-disabled">ІПН</div>
      <div class="font-weight-bold">{{ keyInfo.subjDRFOCode }}</div>
    </v-col>

    <v-col class="py-0" cols="6">
      <div class="text-disabled">Місто</div>
      <div class="font-weight-bold">{{ keyInfo.subjLocality }}</div>
    </v-col>
    <v-col class="py-0" cols="6">
      <div class="text-disabled">Орган що видав</div>
      <div class="font-weight-bold">{{ keyInfo.issuerCN }}</div>
    </v-col>

    <v-col class="py-0" cols="12">
      <div class="text-disabled">Номер сертифікату</div>
      <div class="font-weight-bold">{{ keyInfo.serial }}</div>
    </v-col>

    <v-col class="py-0" cols="6">
      <div class="text-disabled">Дата початку</div>
      <div class="font-weight-bold">
        {{ new CustomDate(keyInfo.privKeyBeginTime).toString({ time: true }) }}
      </div>
    </v-col>
    <v-col class="py-0" cols="6">
      <div class="text-disabled">Дата закінчення</div>
      <div class="font-weight-bold">
        {{ new CustomDate(keyInfo.privKeyEndTime).toString({ time: true }) }}
      </div>
    </v-col>
    <v-col class="py-0" cols="6">
      <div class="text-disabled">Тип сертифікату</div>
      <div
        class="font-weight-bold d-flex align-center ga-2"
        :class="{ 'text-error': !keyInfo.isPowerCert }">
        <span>
          {{ keyInfo.isPowerCert ? 'Кваліфікований' : 'Удосконалений' }}
        </span>
        <v-menu v-if="!keyInfo.isPowerCert" open-on-hover>
          <template #activator="{ props }">
            <v-icon
              class="cursor-pointer"
              icon="mdi-information-variant"
              color="error"
              size="small"
              v-bind="props"></v-icon>
          </template>

          <v-card width="800">
            <v-card-text
              class="text-body-1 text-medium-emphasis"
              style="line-height: 1.7">
              <div class="d-flex align-center mb-4">
                <v-icon color="error" class="me-3"> mdi-alert-circle </v-icon>
                <span class="font-size-18 font-weight-bold text-error">
                  Шановний користувач!
                </span>
              </div>

              <p class="mb-4">
                Звертаємо Вашу увагу на те, що із набуттям чинності
                <span class="font-weight-bold text-high-emphasis">
                  07.11.2018
                </span>
                Закону України
                <span class="font-weight-bold text-high-emphasis">
                  «Про електронну ідентифікацію та електронні довірчі послуги»
                </span>
                та відповідно до
                <span class="font-weight-bold text-high-emphasis">
                  частини 2 статті 17
                </span>
                цього закону, використання кваліфікованого сертифікату
                відкритого ключа
                <span class="font-weight-bold text-error">є обов’язковим</span>.
              </p>

              <v-divider class="mb-4" />

              <div>
                Просимо звернутися до свого
                <span class="font-weight-bold text-high-emphasis">
                  суб’єкта надання електронних довірчих послуг
                </span>
                для отримання кваліфікованого сертифікату відкритого ключа.
              </div>
            </v-card-text>
          </v-card>
        </v-menu>
      </div>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { CustomDate } from 'best-modules/utils'
import { PropType } from 'vue'
import * as EUSignCP from 'euscp'

export default {
  name: 'KeyInfo',
  props: {
    keyInfo: {
      type: Object as PropType<EUSignCP.EndUserCertificateInfoEx>,
      required: true,
    },
  },
  methods: { CustomDate },
}
</script>

<style scoped lang="scss"></style>
